module.exports = __webpack_public_path__ + "static/media/LOGO.bfd08d36.png";